import React, {useState} from 'react';
import RegistrationForm from "./RegistrationForm";
import {Container} from "@material-ui/core";
import DoneIcon from '@material-ui/icons/Done';
import InfoPageComponents from "../core/auth/InfoPageComponents";

const RegistrationSuccessComponent = () => {
    return <InfoPageComponents caption="form.registration.success.inquiry-submitted"
                               icon={<DoneIcon/>}
                               infoMessages={[
                                   "form.registration.success.inquiry-received",
                                   "form.registration.success.review-request"
                               ]}
    />
};


const RegistrationPageComponents = () => {
    const [success, setSuccess] = useState(false);

    return (<Container>
        {success ? <RegistrationSuccessComponent/> : <RegistrationForm onSuccess={() => setSuccess(true)}/>}
    </Container>);
};

export default RegistrationPageComponents;